import { render, staticRenderFns } from "./RouteItem.vue?vue&type=template&id=6965fca0"
import script from "./RouteItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./RouteItem.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports